import type { Nav4RolloutMobile, Nav4RolloutNone } from './types.tsx';

export const NAV4_ROLLOUT_NONE: Nav4RolloutNone = { stage: 'none' };

export const NAV4_ROLLOUT_MOBILE: Nav4RolloutMobile = { stage: 'mobile' };
